import { render, staticRenderFns } from "./ProductsSlider.vue?vue&type=template&id=2e8521c6&lang=pug&"
import script from "./ProductsSlider.vue?vue&type=script&lang=js&"
export * from "./ProductsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports